import { render, staticRenderFns } from "./DocumentExportModal.vue?vue&type=template&id=8b50beba"
import script from "./DocumentExportModal.vue?vue&type=script&lang=js"
export * from "./DocumentExportModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentExportModal.vue?vue&type=style&index=0&id=8b50beba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports